var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.paymentCardsExist
    ? _c("div", { staticClass: "payment-info-box" }, [
        _c(
          "div",
          { staticClass: "payment-top-area" },
          [
            _vm._m(0),
            _c(
              "UiButton",
              {
                attrs: { size: "sm", variant: "blue" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push(`/profile/user`)
                  },
                },
              },
              [_vm._v(" Add Credit Card ")]
            ),
          ],
          1
        ),
        _vm._m(1),
        _c("span", { staticClass: "payment-danger" }, [
          _vm._v(
            " Please add a Credit Card to continue access to ProveraCare. "
          ),
        ]),
      ])
    : _c("div", { staticClass: "payment-info-box" }, [
        _c(
          "div",
          { staticClass: "payment-top-area" },
          [
            _c("div", { staticClass: "payment-duration-info" }, [
              _c("strong", { staticClass: "payment-title" }, [
                _vm._v("Billing information"),
              ]),
              _vm.isTrialPeriod
                ? _c("strong", { staticClass: "payment-invoice" }, [
                    _vm._v("Next invoice: "),
                    _c("span", { staticClass: "payment-unavailable" }, [
                      _vm._v("n/a"),
                    ]),
                  ])
                : _c("strong", { staticClass: "payment-invoice" }, [
                    _vm._v("Next invoice: "),
                    _c("span", { staticClass: "payment-unavailable" }, [
                      _vm._v(_vm._s(_vm.getBillCurrentPeriodEndDate)),
                    ]),
                  ]),
            ]),
            _c(
              "UiButton",
              {
                attrs: { size: "sm", variant: "blue" },
                on: {
                  click: function ($event) {
                    return _vm.$router.push(`/profile/user`)
                  },
                },
              },
              [_vm._v(" Update billing ")]
            ),
          ],
          1
        ),
        _vm.paymentDetails
          ? _c("ul", { staticClass: "payment-list-info" }, [
              _c("li", [_vm._v("**** " + _vm._s(_vm.paymentDetails?.last4))]),
              _c("li", [_vm._v(_vm._s(_vm.UserName))]),
              _c("li", [
                _vm._v(
                  " EXP: " +
                    _vm._s(_vm.paymentDetails?.exp_year) +
                    "/" +
                    _vm._s(_vm.paymentDetails?.exp_month) +
                    " "
                ),
              ]),
            ])
          : _vm._e(),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "payment-duration-info" }, [
      _c("strong", { staticClass: "payment-title" }, [
        _vm._v("Billing information"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("strong", { staticClass: "payment-invoice" }, [
      _vm._v("Next invoice: "),
      _c("span", { staticClass: "payment-unavailable" }, [_vm._v("n/a")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }